import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Tours from "./components/Tours";
import Destinations from "./components/Destinations";
import Reviews from "./components/Reviews";
import SpanishPresentation from "./components/SpanishPresentation";
import Contact from "./components/Contact";
import About from "./components/About";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import EntryPopup from "./components/EntryPopup";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Blog from "./components/Blog";
import TourDetail from "./components/TourDetail";
import PreContractInfo from "./components/PreContractInfo";
import TermsOfTravel from "./components/TermsOfTravel";
import InsuranceInfo from "./components/InsuranceInfo";
import PaymentInfo from "./components/PaymentInfo";
import ComplaintsInfo from "./components/ComplaintsInfo";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import Travelogue from "./components/Travelogue";
import TravelogueDetail from "./components/TravelogueDetail";
import SEO from "./components/SEO";

function Home() {
  return (
    <div className="app">
      <SEO 
        title="TraveLina - Putovanja u Španjolsku | Agencija za putovanja"
        description="Putovanja u manjim grupama, personalizirane ture i potpuna podrška na hrvatskom i španjolskom jeziku. Učenje španjolskog jezika, gastronomska iskustva i autentična putovanja u Španjolsku."
        keywords="putovanja Španjolska, agencija za putovanja, učenje španjolskog, Valladolid, Madrid, Salamanca, Segovia, gastronomska putovanja, vinske rute, španjolska kultura"
      />
      <Navbar />
      <EntryPopup />
      <main>
        <Hero />
        <Tours />
        <Destinations />
        <About />
        <Reviews />
        <SpanishPresentation />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/tour/:tourKey" element={<TourDetail />} />
      <Route path="/tour/:tourKey/precontract" element={<PreContractInfo />} />
      <Route path="/terms" element={<TermsOfTravel />} />
      <Route path="/insurance" element={<InsuranceInfo />} />
      <Route path="/payment" element={<PaymentInfo />} />
      <Route path="/complaints" element={<ComplaintsInfo />} />
      <Route path="/travelogue" element={<Travelogue />} />
      <Route path="/travelogue/:travelogueKey" element={<TravelogueDetail />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

export default App;
